/* @ngInject */
export default function (APIService, Upload) {
	return {
		...APIService.service('documents'),

		uploadToStorage: (uploadParams, file) => {
			return Upload.upload({
				url:               uploadParams.attributes.action,
				method:            uploadParams.attributes.method,
				data:              {
					...uploadParams.inputs,
					file,
				},
				skipAuthorization: true,
			});
		},

		permissionsReport: () => {
			return APIService.service('documents')
			                 .one('permissions-report')
			                 .get();

		},
	};
};


// WEBPACK FOOTER //
// ./src/js/factories/documents/documents/index.js